import styled from "styled-components";

export const Card = styled.div`
  margin: 0 0 20px 0;
  background-color: ${props => props.theme.colors[0]};
  border-radius: 4px;
  box-shadow: 0 6px 18px 0 ${props => props.theme.colors[16]};

  form {
  }

  label {
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.01em;
    color: ${props => props.theme.colors[27]};
  }

  input {
    background-color: transparent;
    color: ${props => props.theme.colors[23]};
    border: none;
    border-radius: 0;
    outline: none;

    &:not(:disabled) {
      border-bottom: 1px solid ${props => props.theme.colors[17]};
    }

    &:focus {
      background-color: transparent;
      box-shadow: none;
    }

    &:disabled {
      background-color: transparent;
    }
  }

  button {
    padding: 4px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: ${props => props.theme.colors[0]};
    background-color: ${props => props.theme.colors[21]};
    transition: 0.2s background-color ease-in;

    &:hover,
    &:active,
    &:focus {
      background-color: ${props => props.theme.colors[29]} !important;
    }
  }
`;

export const Header = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 19px;
  letter-spacing: 0.01em;
  color: ${props => props.theme.colors[28]};
  padding: 20px 24px;
  border-bottom: 1px solid ${props => props.theme.colors[17]};
`;

export const Body = styled.div`
  padding: 20px 24px;
`;

export const Title = styled.h1`
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: ${props => props.theme.colors[23]};
  margin: 0 0 10px;
`;
